export const TransportTypes = {
  IProgrammingTransportService: Symbol("IProgrammingTransportService"),
};
